var render, staticRenderFns
import script from "./RegistrationStepper.vue?vue&type=script&lang=js&"
export * from "./RegistrationStepper.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationStepper.vue?vue&type=style&index=0&id=0569169d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0569169d",
  null
  
)

export default component.exports